// extracted by mini-css-extract-plugin
module.exports = {"heading":"PopupHeader_heading__29dnS","close":"PopupHeader_close__2jytG"};